import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { TopBar, Rail, DeckControls } from "./components/Chrome";
import { Slide } from "./components/Deck";
import Marquee from "./components/Marquee";
import Slide01Hero from "./components/slides/Slide01Hero";
import Slide02Gap from "./components/slides/Slide02Gap";
import Slide03What from "./components/slides/Slide03What";
import Slide04How from "./components/slides/Slide04How";
import Slide05AI from "./components/slides/Slide05AI";
import Slide06Patients from "./components/slides/Slide06Patients";
import Slide07Clinicians from "./components/slides/Slide07Clinicians";
import Slide08Hospitals from "./components/slides/Slide08Hospitals";
import Slide09Corporate from "./components/slides/Slide09Corporate";
import Slide10Commitments from "./components/slides/Slide10Commitments";
import Slide11Next from "./components/slides/Slide11Next";
import DeckAccess from "./pages/DeckAccess";

const SLIDES = [
  { id: "slide-01", label: "Title" },
  { id: "slide-02", label: "The gap" },
  { id: "slide-03", label: "What PranIQ is" },
  { id: "slide-04", label: "How it works" },
  { id: "slide-05", label: "PranIQ AI" },
  { id: "slide-06", label: "For patients" },
  { id: "slide-07", label: "Doctors & clinicians" },
  { id: "slide-08", label: "Hospitals & clinics" },
  { id: "slide-09", label: "Corporate tie-in" },
  { id: "slide-10", label: "Our commitments" },
  { id: "slide-11", label: "Next steps" },
];

const goToSlide = (i) => {
  const count = SLIDES.length;
  const target = document.querySelectorAll("[data-slide]")[
    Math.max(0, Math.min(count - 1, i))
  ];
  target?.scrollIntoView({ behavior: "smooth", block: "start" });
};

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function DeckHome() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActive(Number(entry.target.dataset.slide));
          }
        });
      },
      { rootMargin: "-45% 0px -45% 0px", threshold: 0 }
    );
    document
      .querySelectorAll("[data-slide]")
      .forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const onKey = (e) => {
      const tag = e.target?.tagName;
      if (["INPUT", "TEXTAREA", "SELECT", "BUTTON"].includes(tag)) return;
      if (["ArrowDown", "PageDown", " "].includes(e.key)) {
        e.preventDefault();
        goToSlide(active + 1);
      } else if (["ArrowUp", "PageUp"].includes(e.key)) {
        e.preventDefault();
        goToSlide(active - 1);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [active]);

  return (
    <main className="bg-bone font-sans text-inktext antialiased">
      <TopBar active={active} goTo={goToSlide} slides={SLIDES} />
      <Rail active={active} goTo={goToSlide} slides={SLIDES} />
      <DeckControls active={active} goTo={goToSlide} slides={SLIDES} />

      <Slide01Hero goTo={goToSlide} />
      <Marquee />

      <Slide index={1} label="The gap" bg="bg-bone2">
        <Slide02Gap />
      </Slide>
      <Slide index={2} label="What PranIQ is" bg="bg-bone">
        <Slide03What />
      </Slide>
      <Slide index={3} label="How it works" bg="bg-mint">
        <Slide04How />
      </Slide>
      <Slide index={4} label="PranIQ AI" bg="bg-bone">
        <Slide05AI />
      </Slide>
      <Slide index={5} label="For patients" bg="bg-bone2">
        <Slide06Patients />
      </Slide>
      <Slide index={6} label="Doctors & clinicians" bg="bg-bone">
        <Slide07Clinicians />
      </Slide>
      <Slide index={7} label="Hospitals & clinics" bg="bg-mint">
        <Slide08Hospitals />
      </Slide>
      <Slide index={8} label="Corporate tie-in" bg="bg-bone2">
        <Slide09Corporate />
      </Slide>
      <Slide index={9} label="Our commitments" bg="bg-ink" dark>
        <Slide10Commitments />
      </Slide>
      <Slide index={10} label="Next steps" bg="bg-bone" id="contact">
        <Slide11Next />
      </Slide>
    </main>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<DeckHome />} />
        <Route path="/deck" element={<DeckAccess />} />
      </Routes>
      <Toaster position="bottom-right" richColors />
    </BrowserRouter>
  );
}

export default App;
